import { useWorkspaces } from "./WorkspaceProvider";

const labels = {
  PERSONAL: "Personal",
  PRACTITIONER: "Practitioner",
  BUSINESS: "Business",
  COLLECTIVE: "Collective",
} as const;

export function WorkspaceSwitcher() {
  const {
    workspaces,
    activeWorkspace,
    isLoading,
    isSwitching,
    switchWorkspace,
  } = useWorkspaces();

  return (
    <label className="flex items-center gap-2 text-sm font-medium">
      <span className="sr-only">Active workspace</span>
      <select
        aria-label="Active workspace"
        className="max-w-60 rounded-full border border-separator bg-background px-4 py-2"
        disabled={isLoading || isSwitching}
        value={activeWorkspace?.id ?? ""}
        onChange={(event) => void switchWorkspace(event.target.value)}
      >
        {workspaces.map((workspace) => (
          <option key={workspace.id} value={workspace.id}>
            {workspace.name} · {labels[workspace.type]} ·{" "}
            {workspace.roleKeys.join(", ")}
          </option>
        ))}
      </select>
    </label>
  );
}
